import { ActionTree, GetterTree, MutationTree } from "vuex";
import { SimDeliveryStoreType } from "@/types/SimDeliveryTypes";

const deliveryInstructions: SimDeliveryStoreType = {
  deliveryType: "SIM_DELIVERY",
  viewAddress: {
    active: true,
    message:
      "Você <b>receberá um código por SMS no telefone informado</b> após o pagamento do pedido. Você deverá <b>fornecer esse código ao entregador</b> para confirmar sua entrega. ",
  },
  viewInstructions: [
    "Após a confirmação da compra, o chip será entregue em um prazo de até 24 horas*.",
    "Você <b>receberá um código por SMS no telefone informado</b> após o pagamento do pedido. Você deverá <b>fornecer esse código ao entregador</b> para confirmar sua entrega.",
    "*Horário de entrega: segunda a sexta, das 8h às 20h; sábado das 8h às 16h.",
    "<b>Fique tranquilo!</b>",
    "Seu plano inicia somente quando <br/>você ativar o seu chip.",
  ],
  viewSuccess: {
    instructions: [
      "Se ainda não tiver o app instalado, faça a instalação pelo Google Play ou App Store",
      "Ao abrir o app, clique no botão <b>“Já sou Claro flex”</b> e em seguida no botão  <b>“Primeiro acesso”</b> para cadastrar sua senha no Flex.",
      "<b>Acompanhe a entrega</b> do seu chip pelo app.",
      "Informe o código que foi enviado por SMS ao entregador para confirmar sua entrega.",
      "Após a entrega, <b>insira o chip</b> no celular e <b>conclua sua ativação.</b>",
    ],
  },
};

const conventionalInstructions: SimDeliveryStoreType = {
  deliveryType: "CONVENTIONAL",
  viewAddress: {
    active: false,
    message: "",
  },
  viewInstructions: [
    "Após a confirmação da compra, o chip será entregue em um prazo de até 24 horas*.",
    "*Horário de entrega: segunda a sexta, das 8h às 20h; sábado das 8h às 16h.",
    "<b>Fique tranquilo!</b>",
    "Seu plano inicia somente quando <br/>você ativar o seu chip.",
  ],
  viewSuccess: {
    instructions: [
      "Se ainda não tiver o app instalado, faça a instalação pelo Google Play ou App Store",
      "Ao abrir o app, clique no botão <b>“Já sou Claro flex”</b> e em seguida no botão  <b>“Primeiro acesso”</b> para cadastrar sua senha no Flex.",
      "<b>Acompanhe a entrega</b> do seu chip pelo app.",
      "Após a entrega, <b>insira o chip</b> no celular e <b>conclua sua ativação.</b>",
    ],
  },
};

const state: SimDeliveryStoreType = {
  ...conventionalInstructions,
};

const getters: GetterTree<SimDeliveryStoreType, any> = {
  deliveryType: (state) => state.deliveryType,
  viewAddress: (state) => state.viewAddress,
  viewInstructions: (state) => state.viewInstructions,
  viewSuccess: (state) => state.viewSuccess,
};

const mutations: MutationTree<SimDeliveryStoreType> = {
  setDeliveryType: (state, deliveryType) => (state.deliveryType = deliveryType),
  setDeliveryMessages: (
    state,
    deliveryType: "SIM_DELIVERY" | "CONVENTIONAL"
  ) => {
    const newState: SimDeliveryStoreType =
      deliveryType === "CONVENTIONAL"
        ? conventionalInstructions
        : deliveryInstructions;

    state.deliveryType = newState.deliveryType;
    state.viewAddress = newState.viewAddress;
    state.viewInstructions = newState.viewInstructions;
    state.viewSuccess = newState.viewSuccess;
  },
};
const actions: ActionTree<SimDeliveryStoreType, any> = {
  setDeliveryType: ({ commit }, deliveryType) =>
    commit("setDeliveryType", deliveryType),
  setDeliveryMessages: (
    { commit },
    deliveryType: "SIM_DELIVERY" | "CONVENTIONAL"
  ) => commit("setDeliveryMessages", deliveryType),
};

export default {
  state,
  getters,
  mutations,
  actions,
};
